import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../ducks'

export default function useCurrentUser() {
  // returns { ...user, userAccount, userMetadata, userRecent, userStatus }
  return useSelector(currentUserSelector)
}
